import { FC } from "react";

import styles from "../headerBtn.module.scss";

interface ISettingsOptions {
  setSelectedRoutesSettings: (el: string[]) => void;
  selectedRoutesSettings: string[];
  isCheckedFullInfo: boolean;
  setIsCheckedFullInfo: (check: boolean) => void;
}

const options = [
  { value: "routeNo", label: "№ маршрута" },
  { value: "merch", label: "Мерчендайзер" },
  { value: "visitType", label: "Тип посещения" },
  { value: "sync", label: "Синхронизация" },
  { value: "checkin", label: "Первый чекин" },
  { value: "checkout", label: "Последний чекаут" },
  { value: "smena", label: "Смена" },
  { value: "plan", label: "План" },
  { value: "sdano", label: "Сдано" },
  { value: "diff", label: "Разница" },
  { value: "login", label: "Логин/Локация" },
  { value: "employeeStatus", label: "Статус сотрудника" },
  { value: "routeType", label: "Тип маршрута" },
  { value: "vacancyName", label: "Название вакансии" },
  { value: "vsv", label: "ВСВ" },
  { value: "supervisor", label: "Супервайзер" },
  { value: "tt", label: "Кол-во ТТ на маршруте" },
  { value: "visitsOnWeek", label: "Плановое кол-во визитов в неделю" },
  { value: "income", label: "Выручка" },
  { value: "plannedWage", label: "Зарплата" },
];

const RoutesSettingsSection: FC<ISettingsOptions> = ({
  setSelectedRoutesSettings,
  selectedRoutesSettings,
  setIsCheckedFullInfo,
  isCheckedFullInfo,
}) => {
  const handleChangeCheckbox = (name: string) => {
    const updatedSettings = selectedRoutesSettings.includes(name)
      ? selectedRoutesSettings.filter((elem: string) => elem !== name)
      : [...selectedRoutesSettings, name];

      setSelectedRoutesSettings(updatedSettings);
    setIsCheckedFullInfo(false);
  };

  const handleChangeFullInfoCheckbox = () => {
    if (!isCheckedFullInfo) {
      const allSettings = options.map((option) => option.value);
      setSelectedRoutesSettings(allSettings);
    } else {
      setSelectedRoutesSettings([]);
    }
    setIsCheckedFullInfo(!isCheckedFullInfo);
  };

  return (
    <div className={styles.settings__block_info}>
      <div className={styles.check__list_block}>
        {options.map((option) => (
          <div key={option.value} className={styles.check__list_elem}>
            <label className={styles.checkbox__container}>
              <input
                checked={selectedRoutesSettings.includes(option.value)}
                type="checkbox"
                onChange={() => handleChangeCheckbox(option.value)}
              />
              <span className={styles.multi__reason_checkmark}></span>
            </label>
            {option.label}
          </div>
        ))}
        <div className={styles.check__list_elem}>
          <label className={styles.checkbox__container}>
            <input
              type={"checkbox"}
              onChange={handleChangeFullInfoCheckbox}
              checked={isCheckedFullInfo || (options.length === selectedRoutesSettings.length)}
            />
            <span className={styles.multi__reason_checkmark}></span>
          </label>
          Все
        </div>
      </div>
    </div>
  );
};

export default RoutesSettingsSection;
